import React from 'react';
import { Link } from 'react-router';
import partial from 'lodash/partial';
import Featured from 'marketing/common/featured';
import WhyCS from 'marketing/common/whyCS';
import Cta from 'marketing/common/cta';
import Support from 'marketing/containers/support';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import IntercomChat from 'common/containers/intercom_chat';
import Reviews from 'marketing/containers/reviews';
import {
  trackMixpanel, trackClickWithMixpanel,
  MP_VIEWED_MARKETING_PAGE_EVENT_NAME, MP_CLICKED_GET_STARTED_EVENT_NAME,
  MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME
} from 'common/tracking';
import ReviewsAggMetadata from 'marketing/containers/reviews_agg_metadata';
import { fetchReviewStatsIfNeeded } from 'marketing/ducks';

export default class TestimonialsPage extends React.Component {
  componentDidMount() {
    trackMixpanel(
      MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
      {
        "pageName": "Testimonials"
      }
    )
  }

  render() {
    const { stats } = this.props;

    return (
      <div className="l-content" id="content">
        <Meta
          title="crowdspring Reviews & Testimonials"
          meta={[
            { name: 'robots', content: 'index,follow' },
            { name: 'description', content: "Read real crowdspring reviews and see why over 60,000 brands, businesses, agencies and non-profits trust crowdspring for custom graphic design, logos, websites, product design and naming for your business. "},
            { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' },
            { property: 'og:title', content: 'crowdspring testimonials' },
            { property: 'og:description', content: "Hear what our customers are saying about crowdspring, the world's #1 marketplace for logo design, web design, and naming." },
            { property: 'og:url', content: getCanonicalURL('/reviews/') },
          ]}
          link={[{ rel: 'canonical', href: getCanonicalURL('/reviews/') }]} />

        <section className="block block-hero">
          <div className="row columns">
            <h1 className="hero-title">crowdspring Reviews</h1>
          </div>
          <div className="row">
            <div className="small-16 medium-12 columns">
              <ReviewsAggMetadata />
              <h3 className="hero-subtitle">
                Our customers know how to make us blush. <br className="hide-for-small-only" />
                We're rated { stats.avg || 0 }/5 from { (stats.count || 0).toLocaleString() } customer
                reviews. <br className="hide-for-small-only" />
                We&apos;re&nbsp;<span className="hide-for-small-only">really </span>flattered by what
                they&apos;ve said&hellip;
              </h3>
              <div className="hero-actions">
                <Link to="/case-studies/" className="btn btn-text">
                  Check out these recent client case studies <i className="fa fa-long-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
        </section>

        <Reviews />

        <section className="block block-clients">
          <div className="row columns">
            <div className="block-header">
              <h2>Thousands of satisfied&nbsp;customers, large&nbsp;&&nbsp;small.</h2>
            </div>
          </div>
          <div className="row">
            <div className="small-8 medium-4 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_amazon-2x.jpg" alt="Amazon" />
            </div>
            <div className="small-8 medium-4 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_aliexpress-2x.jpg" alt="AliExpress" />
            </div>
            <div className="small-8 medium-4 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_lg-2x.jpg" alt="LG" />
            </div>
            <div className="small-8 medium-4 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_starbucks-2x.jpg" alt="Starbucks" />
            </div>
          </div>
          <div className="row align-center">
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_barilla-2x.jpg" alt="Barilla" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_brammo-2x.jpg" alt="Brammo" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_citysearch-2x.jpg" alt="Citysearch" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_fcb-2x.jpg" alt="FCB" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_grolsch-2x.jpg" alt="Grolsch" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_madison-childrens-2x.jpg" alt="Madison Children's Museum" />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_st-croix-chocolate-2x.jpg" alt="St. Croix Chocolate Co." />
            </div>
            <div className="small-6 medium-2 columns client">
              <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_testimonials_client-logo_tivo-2x.jpg" alt="Tivo" />
            </div>
          </div>
        </section>

        <section className="block block-ratings">
          <div className="row columns text-center">
            <div className="small-16 columns">
              <h2>Still not convinced?</h2>

              <p>
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
              </p>
              <p>
                Check out our {' '}
                <a href="https://www.resellerratings.com/store/Crowdspring_com" target="_blank">
                  <span onClick={partial(trackClickWithMixpanel, "Clicked 200+ reviews", {pageName: "Testimonials", pageArea: "Still not convinced?"})}>
                    200+ five-star reviews <i className="fa fa-long-arrow-right" />
                  </span>
                </a>
              </p>
            </div>
          </div>
          <Featured />
        </section>

        <Cta
          title="Get a design your customers will love."
          eventTracking={{
            eventName: MP_CLICKED_GET_STARTED_EVENT_NAME,
            eventData: {
              pageName: "Testimonials",
              pageArea: "CTA",
            }
          }}
          cta={{
            label: 'Get Started',
            url: '/start-a-project/'
          }}
          blockClasses="pink invert-text"
          image={{
            url: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_cta-2x.png',
            alt: 'Pills by JCarlos',
            attribution: 'JCarlos'
          }}
          post_cta_html="Have questions? <br /><a href='/help/contact/consultation/'>Request a Free Design Consultation <i class='fa fa-long-arrow-right'></i></a>"
        />

        <WhyCS />

        <Support
          consultationEventTracking={{
            eventName: MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME,
            eventData: {
              pageName: "Testimonials",
              version: "english",
              pageArea: "Support footer",
            }
          }}
        />

        <IntercomChat />
      </div>);
  }
};

TestimonialsPage.need = [fetchReviewStatsIfNeeded];



// WEBPACK FOOTER //
// ./marketing/testimonials.jsx